/**
 * useMastersRefresh — wires a voucher form to a global "masters:refresh" event.
 *
 * Pattern in a voucher page:
 *   const mastersRefreshKey = useMastersRefresh();
 *   useEffect(() => { ...load clients / vendors / items... }, [..., mastersRefreshKey]);
 *
 * Then place <RefreshMastersButton /> in the form header. Clicking it dispatches
 * the event, every mounted voucher form re-reads master lookups, but each form's
 * own header / line-item state is untouched (it lives in separate useState slots).
 */
import { useEffect, useState } from "react";

export const MASTERS_REFRESH_EVENT = "masters:refresh";

export function triggerMastersRefresh() {
  window.dispatchEvent(new CustomEvent(MASTERS_REFRESH_EVENT));
}

export function useMastersRefresh() {
  const [refreshKey, setRefreshKey] = useState(0);
  useEffect(() => {
    const handler = () => setRefreshKey(k => k + 1);
    window.addEventListener(MASTERS_REFRESH_EVENT, handler);
    return () => window.removeEventListener(MASTERS_REFRESH_EVENT, handler);
  }, []);
  return refreshKey;
}
